import React from "react"

/**
 * Returns `true` on the first mount
 *
 * Note: in strict mode this hook will return `true` twice
 * @see https://react.dev/reference/react/StrictMode#fixing-bugs-found-by-re-running-effects-in-development
 */
const useInitialMount = () => {
  const isInitialMount = React.useRef(true)

  React.useEffect(() => {
    isInitialMount.current = false
  }, [])

  return isInitialMount.current
}

export default useInitialMount
